import React, { useState, useEffect, useMemo } from "react";
import * as dateFns from "date-fns";
import CalendarHeader from "./CalendarHeader";
import CalendarGrid from "./CalendarGrid";
import { CardWithActions, Legend, LineDivider } from "@/components";
import AttendanceInfoModal from "./AttendanceInfoModal";
import { legendItems } from "@/pages/attendance/views/calender/Legend";
import { useGetCalendarQuery, useGetPayrollLockDateInfoQuery, useGetPayrollLockDateQuery } from "@/api/services/attendance/calendar/Calendar";
import { format, subMonths, addMonths, isBefore, isEqual, startOfDay  } from "date-fns";
import { useSelector } from "react-redux";
import { Leave } from "@/icons";

const Calendar = () => {

  const [currentMonth, setCurrentMonth] = useState(new Date());
  const [yearMonth, setYearMonth] = useState(format(new Date(), "MM-yyyy"));
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedDay, setSelectedDay] = useState(null);

  const { data: lockDate, refetch: refetchLockInfo } = useGetPayrollLockDateQuery({yearMonth: yearMonth });

  const getLockMonth = useMemo(() => {
    // if (!lockDate?.data) return null;
    if (!lockDate?.data?.payrollMonth) return yearMonth;
    const { startDate, endDate } = lockDate.data.payrollMonth;
    const end = startOfDay(new Date(endDate));
    const presentDate = startOfDay(new Date(currentMonth));
    const nextMonth = new Date(currentMonth);
    nextMonth.setDate(1); 
    nextMonth.setMonth(nextMonth.getMonth() + 1);
    const currentLockMonth = format(presentDate, "MM-yyyy"); 
    const nextLockMonth = format(nextMonth, "MM-yyyy");
    // return presentDate >= end ? currentLockMonth : nextLockMonth;
    return isBefore(presentDate, end) || isEqual(presentDate, end)
    ? currentLockMonth
    : nextLockMonth;
  }, [lockDate, currentMonth,yearMonth]); 
  

  const { data: isLocked, refetch: refetchPayrollLockDate } = useGetPayrollLockDateInfoQuery({ yearMonth: getLockMonth },
    {
      skip: !getLockMonth
    }
  );
  const lockDateRecords = isLocked?.data || [];

  // const userDetails = useSelector((state) => state.employee?.userDetails);
  const localStorageData = JSON.parse(localStorage.getItem("loginDetails"));
  const userDetails = localStorageData?.userDetails || {};
  const empId = userDetails?.empId;

  const { data: data, refetch: refetchCalendar } = useGetCalendarQuery(
    { empIds: empId, dateObj: getLockMonth  },
    { skip: !getLockMonth  }
  );
  const attendanceRecords = data?.data || [];

  const handlePrevMonth = () => {
    let monthYear = lockDateRecords?.monthYear;
    if (!monthYear) return;
    const [month, year] = monthYear.split("-").map(Number);
    const val = new Date(year, month - 1, 1);
    const newMonth = subMonths(val, 1);
    const updatedMonth = format(newMonth, "MM-yyyy");
    setCurrentMonth(newMonth);
    setYearMonth(updatedMonth); 
    refetchPayrollLockDate();
    refetchLockInfo();
    refetchCalendar();
  };

  const handleNextMonth = () => {
    let monthYear = lockDateRecords?.monthYear;
    if (!monthYear) return;
    const [month, year] = monthYear.split("-").map(Number);
    const val = new Date(year, month - 1, 1);
    const newMonth = addMonths(val, 1); 
    const updatedMonth = format(newMonth, "MM-yyyy");
    setCurrentMonth(newMonth); 
    setYearMonth(updatedMonth); 
    refetchPayrollLockDate();
    refetchLockInfo();
    refetchCalendar();
  };

  const handleDayClick = (day) => {
    const today = new Date();
  const selected = new Date(day);

  // Check if the selected date is in the future
  if (selected > today) {
    return; // Don't open modal if future date
  }
    setSelectedDay(day);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const formatMonthYear = (monthYear) => {
    if (!monthYear) return ""; // Handle null/undefined case
    // Split "03-2025" into [month, year]
    const [month, year] = monthYear.split("-").map(Number);
    // Construct a Date object using the first day of the month
    const date = new Date(year, month - 1, 1); // month - 1 since JS months are 0-based
    // Format as "March 2025"
    return new Intl.DateTimeFormat("en-US", { month: "long", year: "numeric" })?.format(date);
  };

  const formatDate = (date) => {
    return date.toISOString().split("T")[0]; // Example format: YYYY-MM-DD
  };

  const attendanceStatus = (attendanceRecords || []).reduce((acc, record) => {
    acc[record.attendanceDate] = {
      attendanceData: record.attendanceData,
      regularizationData: record.regularization,
      shiftData: record.shift,
      leaveData: record.leave,
    };
    return acc;
  }, {});

  return (
    <div>
      <CardWithActions
        headerTitle="Calendar"
        headerActions={[
          <Legend
            triggerLabel="Legend"
            legendItems={legendItems}
            cardWidth={187}
          />,
        ]}
      >
        <LineDivider thickness={1} />
        <CalendarHeader
          title={formatMonthYear(lockDateRecords?.monthYear)}
          onPrevMonth={handlePrevMonth}
          onNextMonth={handleNextMonth}
        />
        <CalendarGrid
          lockDateRecords={lockDateRecords}
          yearMonth={yearMonth}
          onDayClick={handleDayClick}
          attendanceStatus={attendanceStatus}
        />
      </CardWithActions>
      {selectedDay && (
        <AttendanceInfoModal
          attendanceInfotoggleOpen={openDialog}
          attendanceInfotoggleClose={handleCloseDialog}
          addItemViewRemark={() => { }}
          empId={attendanceRecords?.empId}
          scroll="paper"
          date={formatDate(new Date(selectedDay))}
          day={new Intl.DateTimeFormat("en-US", { weekday: "long" }).format(
            new Date(selectedDay)
          )}
          shift="Shift 1"
          InfoData={attendanceRecords}
          title={`Attendance Details for ${formatDate(new Date(selectedDay))}`} // Example title, adjust as needed
        />
      )}
    </div>
  );
};

export default Calendar;
